import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=bf581ff6&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=bf581ff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf581ff6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf581ff6')) {
      api.createRecord('bf581ff6', component.options)
    } else {
      api.reload('bf581ff6', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=bf581ff6&scoped=true&", function () {
      api.rerender('bf581ff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27l2zJyDc321a/JS/comp/Voucher.vue"
export default component.exports